import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { InProgressIcon } from './status_icons/InProgress.icon';
import { InReviewIcon } from './status_icons/InReview.icon';
import { CompleteIcon } from './status_icons/Complete.icon';
import { InEHRIcon } from './status_icons/InEHRIcon';
import { NoteReadyIcon } from './status_icons/NoteReady.icon';

export const CustomIcons = {
  backlog: <LoadingOutlined style={{ color: '#9e9e9e' }} />,
  prioritized: <CheckCircleOutlined style={{ color: '#ffeb3b' }} />,
  in_progress: <InProgressIcon />,
  scope_review: <CheckCircleOutlined style={{ color: '#ff5722' }} />,
  in_review: <InReviewIcon />,
  in_staging: <CheckCircleOutlined style={{ color: '#26c6da' }} />,
  ready: <CheckCircleOutlined style={{ color: '#66bb6a' }} />,
  complete: <CompleteIcon />,
  shipped: <InEHRIcon />,
  note_ready: <NoteReadyIcon />,
};
